// @flow
import sourceItems from './sourceItems';
import sourceActivity from './sourceActivity';


const filterId: 'source' = 'source';
export default filterId;
export { sourceItems, sourceActivity };
